import React from 'react';

import {
  DefaultFilterButton,
  DefaultFilterColorButton,
} from './filterModalStyles';

const FilterButton = ({
  setIsOpen,
  message,
  width,
  height,
  colorStyle,
  preventDefault = false,
  isDisabled = false,
}) => {
  return (
    <>
      {!colorStyle ? (
        <DefaultFilterButton
          onClick={(e) => {
            if (preventDefault) {
              e.preventDefault();
            }
            setIsOpen(true);
          }}
          height={height}
          width={width}
          disabled={isDisabled}
        >
          <span>{message}</span>
        </DefaultFilterButton>
      ) : (
        <DefaultFilterColorButton
          onClick={(e) => {
            if (preventDefault) {
              e.preventDefault();
            }
            setIsOpen(true);
          }}
          height={height}
          width={width}
          disabled={isDisabled}
        >
          <span>{message}</span>
        </DefaultFilterColorButton>
      )}
    </>
  );
};

export default FilterButton;
